/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

const DISCOUNT_TYPES = {
  END_BILL: "endBill",
  COUPON: "coupon",
  PROMOTION: "promotion",
  POINT: "point",
};

const ModalDiscountList = ({ modalOpenObj, discounts, removeDiscount }) => {
  const calculateTotalDiscount = useCallback(() => {
    if (!Array.isArray(discounts) || discounts.length === 0) return 0;

    return discounts.reduce((total, discount) => {
      const discountValue = parseFloat(
        discount.value || discount.discountPrice || discount.amount || 0
      );
      return total + discountValue;
    }, 0);
  }, [discounts]);

  const getDiscountGrouped = useCallback(() => {
    if (!Array.isArray(discounts) || discounts.length === 0) return [];

    const groupedDiscounts = discounts.reduce((groups, discount) => {
      const type = discount.discountType;
      let displayType = "ส่วนลดอื่นๆ";

      switch (type) {
        case DISCOUNT_TYPES.END_BILL:
          displayType = "ส่วนลดท้ายบิล";
          break;
        case DISCOUNT_TYPES.COUPON:
          displayType = "คูปองส่วนลด";
          break;
        case DISCOUNT_TYPES.PROMOTION:
          displayType = "โปรโมชั่น";
          break;
        case DISCOUNT_TYPES.POINT:
          displayType = "คะแนนแลกส่วนลด";
          break;
        default:
          break;
      }

      if (!groups[displayType]) {
        groups[displayType] = {
          type: displayType,
          discounts: [],
        };
      }

      groups[displayType].discounts.push({
        campaign: discount.name || discount.discountName || `ส่วนลด ${type}`,
        desc: discount.description || getDescriptionFromDiscount(discount),
        amount: parseFloat(
          discount.value || discount.discountPrice || discount.amount || 0
        ),
        option: discount.options || [],
      });

      return groups;
    }, {});

    return Object.values(groupedDiscounts);
  }, [discounts]);

  const getDescriptionFromDiscount = useCallback((discount) => {    
    if (discount.isPercent || discount.discountTypeId === 2) {
      return `ส่วนลด ${discount.amount || discount.percent || 0}%`;
    } else {
      return `ส่วนลด ${discount.amount || discount.value || discount.discountPrice || 0} บาท`;
    }
  }, []);

  const handleRemoveDiscount = useCallback(
    (discount) => {
      if (removeDiscount && discount) {
        removeDiscount(discount.discountType);

        if (discounts.length <= 1) {
          modalOpenObj.setModalOpen(false);
        }
      }
    },
    [discounts, modalOpenObj, removeDiscount]
  );

  const groupedDiscounts = getDiscountGrouped();
  const totalDiscount = calculateTotalDiscount();

  return (
    <div>
      <Modal
        aria-labelledby="discount-list-modal-title"
        aria-describedby="discount-list-modal-description"
        open={modalOpenObj.modalOpen}
        onClose={() => modalOpenObj.setModalOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpenObj.modalOpen}>
          <div className="bg-white w-[480px] p-[min(2.44vw,25px)] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-[min(1.46vw,15px)] leading-[1.8]">
            <p className="text-24 font-[500]">รายละเอียดส่วนลดที่ได้รับ</p>

            {groupedDiscounts.length > 0 ? (
              groupedDiscounts.map((group, groupIndex) => (
                <div className="mt-4" key={`group-${groupIndex}`}>
                  <div className="flex justify-between text-18 font-[500]">
                    <p>{group.type}</p>
                    <p>มูลค่าส่วนลด</p>
                  </div>

                  {group.discounts?.length > 0 &&
                    group.discounts.map((discount, index) => (
                      <div
                        className="flex justify-between mt-2"
                        key={`discount-${groupIndex}-${index}`}
                      >
                        <div className="flex-grow">
                          <div className="flex items-center">
                            <p className="bg-[#FFD8DA] text-[#F95057] px-2 py-1 rounded inline-block">
                              {discount.campaign}
                            </p>
                            <span
                              className="ml-2 cursor-pointer text-gray-500 hover:text-red-500"
                              onClick={() =>
                                handleRemoveDiscount(
                                  discounts.find(
                                    (d) =>
                                      d.name === discount.campaign ||
                                      d.discountName === discount.campaign
                                  )
                                )
                              }
                            >
                              ×
                            </span>
                          </div>
                          {discount.desc && (
                            <p className="mt-1">- {discount.desc}</p>
                          )}
                          {Array.isArray(discount.option) &&
                            discount.option.length > 0 &&
                            discount.option.map((opt, optIndex) => (
                              <p
                                className="mt-1"
                                key={`option-${groupIndex}-${index}-${optIndex}`}
                              >
                                - {opt}
                              </p>
                            ))}
                        </div>
                        <p className="text-[#F95057] ml-4">
                          -{discount.amount.toFixed(2)}
                        </p>
                      </div>
                    ))}
                </div>
              ))
            ) : (
              <div className="text-center mt-4">ไม่พบรายการส่วนลด</div>
            )}

            <div className="flex justify-between font-[500] text-20 py-4 mt-4 border-t">
              <p></p>
              <p>มูลค่ารวม</p>
              <p className="text-[#F95057]">-{totalDiscount.toFixed(2)}</p>
            </div>

            <div className="text-center mt-4">
              <button
                className="btn bg-green-500 text-white font-[500] w-48 py-2 rounded"
                onClick={() => modalOpenObj.setModalOpen(false)}
              >
                ปิด
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ModalDiscountList;
